import React from 'react';
import styled from 'styled-components';
import { layout } from 'styles/layout';
import { BaseConfetti } from 'elements/confetti/confetti.styles';

export const ConfettiContainer = styled.div`
  display: none;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    position: absolute;
    z-index: -1;
    top: 0;
    width: 100%;
    height: 100%;
  }
`

export const ConfettiElement10 = styled(BaseConfetti).attrs({
  width: 24,
  height: 25,
  viewBox: '0 0 24 25',
  children: <path d="M0 5.49683L11.6027 -0.000121387L23.3295 24.7522L5.99891 18.159L0 5.49683Z" fill="#cd395c"/>
})`
  top: 51px;
  right: 35px;
`

export const ConfettiElement8 = styled(BaseConfetti).attrs({
  width: 24,
  height: 34,
  viewBox: '0 0 24 34',
  children: <path d="M0.831907 23.5499L24.2607 33.3353L10.6682 -5.57899e-05L0.831907 23.5499Z" fill="#FF7062"/>
})`
  top: 16.875%;
  left: 2.7%;
  transform: rotate(75deg);
`

export const ConfettiElement5 = styled(BaseConfetti).attrs({
  width: 28,
  height: 20,
  viewBox: '0 0 28 20',
  children: <path d="M2.00587 1.91399L24.9155 12.3426L8.30573 18.6101L2.00587 1.91399Z" fill="#1CABBF" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round"/>
})`
  top: 36.65%;
  right: 28.75%;
  transform: rotate(78deg);
`

export const ConfettiElement3 = styled(BaseConfetti).attrs({
  width: 207,
  height: 297,
  viewBox: '0 0 207 297',
  children: <path d="M60.4562 0.264624L0.201004 141.346L55.5591 251.991L208.774 296.709L268.301 145.551L216.077 41.169L60.4562 0.264624Z" fill="#963481" />
})`
  top: 36.65%;
  right: -5.25%;
  transform: rotate(-310deg);
`

export const ConfettiElement10B = styled(BaseConfetti).attrs({
  width: 24,
  height: 25,
  viewBox: '0 0 24 25',
  children: <path d="M0 5.49683L11.6027 -0.000121387L23.3295 24.7522L5.99891 18.159L0 5.49683Z" fill="#cd395c" />
})`
  top: 53.575%;
  left: 27.25%;
  transform: rotate(120deg);
`

export const ConfettiElement11 = styled(BaseConfetti).attrs({
  width: 276,
  height: 579,
  viewBox: '0 0 276 579',
  children: <>
    <path d="M26.8988 575.663L157.918 232.362L-232 151.442L26.8988 575.663Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M25.8881 536.568L133.23 247.467L-193.932 176.38L25.8881 536.568Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M24.1405 502.184L109.736 264.448L-158.229 203.362L24.1405 502.184Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M21.133 462.776L84.7531 279.03L-121.343 229.321L21.133 462.776Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M14.898 422.026L55.2094 293.082L-87.6841 253.937L14.898 422.026Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M9.52599 384.661L33.1973 306.45L-53.1631 281.941L9.52599 384.661Z" stroke="#80D1CD" strokeWidth="2.20115"/>
    <path d="M6.54869 349.246L16.1089 316.912L-19.5039 306.557L6.54869 349.246Z" stroke="#80D1CD" strokeWidth="2.20115"/>
  </>
})`
  top: 46.575%;
  left: 0;
`

export const ConfettiElement6 = styled(BaseConfetti).attrs({
  width: 26,
  height: 36,
  viewBox: '0 0 26 36',
  children: <path d="M12.6777 35.3549L25.1831 22.7363L25.1831 12.505L12.6777 5.34058e-05L0.17244 12.505L0.172419 22.7362L12.6777 35.3549Z" fill="#80d1cd"/>
})`
  top: 57.75%;
  right: 60px;
  transform: rotate(-32deg);
`

export const ConfettiElement8B = styled(BaseConfetti).attrs({
  width: 25,
  height: 34,
  viewBox: '0 0 25 34',
  children: <path d="M0.831907 23.5499L24.2607 33.3353L10.6682 -5.57899e-05L0.831907 23.5499Z" fill="#ffdf6e" />
})`
  top: 73%;
  right: 13%;
  transform: rotate(142deg);
`

export const ConfettiElement7B = styled(BaseConfetti).attrs({
  width: 24,
  height: 38,
  viewBox: '0 0 24 38',
  children: <path d="M19.3713 37.4744L23.7889 2.56197L9.82397 0.794923L0.569806 7.97017L19.3713 37.4744Z" fill="#ff7062" />
})`
  bottom: 10%;
  left: 11%;
  transform: rotate(-89deg);
`
